// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner___MGAgO","social":"social___2s-Rx","paragraph":"paragraph___2kJKF"};